import { render, staticRenderFns } from "./pr_setting.vue?vue&type=template&id=6e59cee4&lang=pug&"
import script from "./pr_setting.vue?vue&type=script&lang=js&"
export * from "./pr_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports